import { type PropsWithChildren } from 'react';

import { Navigate, useParams } from 'react-router-dom';

import { productRedirects } from './constants';

export default function DeprecatedRouteRedirector({ children }: PropsWithChildren) {
  const { product } = useParams<{ product?: string }>();
  const deprecatedProductMatch = productRedirects.find(
    ({ deprecatedProductName }) => product === deprecatedProductName
  );

  if (deprecatedProductMatch) {
    return <Navigate to={deprecatedProductMatch.replacementProductUrl} />;
  }

  return <>{children}</>;
}
